import {createHtmlElement} from "./lib/domFunctions";

function setDependentCheckboxes(parentName: string, dependentName: string, invert = false) {
	const parent = document.querySelector(`input[name=${parentName}]`) as HTMLInputElement;
	const dependent = document.querySelector(`input[name=${dependentName}]`) as HTMLInputElement;
	const dependentLabel = document.querySelector(`label[for=${dependentName}]`) as HTMLElement;
	const dependentHidden = createHtmlElement('input', {type: 'hidden', name: dependentName})

	function disableHandler(disabled: boolean) {
		dependent.disabled = disabled;
		dependentLabel.classList.toggle('text-muted', disabled);

		if (disabled && dependent.checked) {
			dependentHidden.value = 'on';
			parent.parentElement?.append(dependentHidden)
		} else {
			dependentHidden.remove()
		}
	}

	function checkedToDisabled(element: HTMLInputElement) {
		if (invert) return element.checked;
		return !element.checked;
	}

	parent.addEventListener('change', () => {
		disableHandler(!checkedToDisabled(parent));
	});

	disableHandler(!checkedToDisabled(parent))
}

export class PropertiesEditPage {
	constructor() {
		setDependentCheckboxes('trolleyLine', 'freeUnloadOnFirstProgramStart');
		setDependentCheckboxes('trolleyLine', 'automaticEmptyContainerReturn');
		setDependentCheckboxes('trolleyLine', 'rolloutLineUseSensorsInLoading');
		setDependentCheckboxes('programGeneratorUsePreviousProgram', 'programGeneratorFixNonProcessPositionOnProgramRebuilding');
	}
}